// This constant will be true on the entry-fs "Big Bundle" and false on the main entry-fs bundle, legacy SSR, and the client bundles
export const IS_SSR_BIG_BUNDLE = false;
// This constant will be true on all entry-fs bundles (e.g main and bb) and false on legacy SSR, and the client bundles
export const IS_MODERN_SSR = false;
